import { Component, OnInit, Inject, Output, EventEmitter } from '@angular/core';
import { formatDate } from '@angular/common';
import { LocalStorageService } from 'ngx-webstorage';
import Swal from 'sweetalert2';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';   ///=== for searching pop up
import { InsuranceCompanyModel } from 'src/app/models/InsuranceCompanyModel';
import { IsuranceCopmanyService } from 'src/app/services/IsuranceCopmanyService';
import { DomSanitizer } from '@angular/platform-browser';
import { PatientAccModel } from 'src/app/models/PatientAccModel';
import { PatientInsuranceModel } from 'src/app/models/PatientInsuranceModel';
import { PatientInsuranceService } from 'src/app/services/PatientInsuranceService';
import swal from 'sweetalert2';

@Component({
  selector: 'app-patient-isurance',
  templateUrl: './patient-isurance.component.html',
  styleUrls: ['./patient-isurance.component.css']
})
export class PatientIsuranceComponent implements OnInit {
    patientcode = '' ;
    medcompany = 0 ;
    patientid = '' ;
    contcompany = '' ;
    expdate =  formatDate(new Date(), 'yyyy-MM-dd', 'en'); 
    medperc = 0 ;
    outpatper = 0 ;
    labperc = 0 ;
    notes = '' ;
    userid = '' ;
    modifaieddate =  formatDate(new Date(), 'yyyy-MM-dd', 'en');
    compcode = '' ;

 
  insid =0;
  myimage :any;
  myimage2 = 'data:image/jpg;base64,'
  imageSrc;
  imageSource: any;
  sellersPermitFile: any;
  sellersPermitString = '';
  wk_Acc_Not = false;
  wk_Acc_Not1 = true;
  CompamyList : InsuranceCompanyModel[]=[];
    @Output() submitClicked = new EventEmitter<any>();
  constructor(public insurancecopmanyserive : IsuranceCopmanyService,
              public patientinsurance : PatientInsuranceModel,
              public patientinsuranceservice : PatientInsuranceService,
               public storage: LocalStorageService,
    private sanitizer: DomSanitizer,
    public dialogRef: MatDialogRef<PatientIsuranceComponent>,
                  @Inject(MAT_DIALOG_DATA)public data: any
  ) { 
    this.patientcode = data.patientcode;
  }

  ngOnInit(): void {
    this.CompamyList = [];
        this.insurancecopmanyserive.getIsuranceCopmanyLookupTop().subscribe((data: InsuranceCompanyModel[]) => {
        for (let i = 0; i < data.length; i++) {
          this.CompamyList[i] = data[i];
        }
      })
      this.RetrivePatientInsurance();
  }
  RetriveCompany(){
        this.insurancecopmanyserive.getIsuranceCopmany(this.medcompany.toString()).subscribe((data: InsuranceCompanyModel) => {
                this.myimage = data.inslogo;
                this.sellersPermitString =  data.inslogo;
                this.myimage =this.sellersPermitString;
                var kk = this.sellersPermitString;

                this.imageSource = this.sanitizer.bypassSecurityTrustResourceUrl('data:image/jpg;base64,' + this.sellersPermitString);
                if(data.inslogo =='' || data.inslogo == null)
                  {
                    this.wk_Acc_Not = false;
                    this.wk_Acc_Not1 = true;
                  }
                  else
                  {
                    this.wk_Acc_Not = true;
                    this.wk_Acc_Not1 = false;
                  }

        }

            );
}
RetrivePatientInsurance(){
     this.patientinsuranceservice.getPatientInsurance(this.patientcode).subscribe((data: PatientInsuranceModel) => {
//      this.patientcode=data.patientcode
      this.medcompany=data.medcompany;
      this.RetriveCompany();
      this.patientid=data.patientid;
      this.contcompany=data.contcompany;
      this.expdate= formatDate(data.expdate, 'yyyy-MM-dd', 'en'); 
      this.medperc=data.medperc;
      this.outpatper=data.outpatper;
      this.labperc=data.labperc;
      this.notes=data.notes;
   
      
        });
}
submitInsurance(){
  if (this.medcompany == 0 || this.medcompany == null){return};
      this.patientinsurance.patientcode= this.patientcode;
      this.patientinsurance.medcompany= this.medcompany;
      this.patientinsurance.patientid= this.patientid;
      this.patientinsurance.contcompany= this.contcompany;
      this.patientinsurance.expdate= formatDate(this.expdate, 'yyyy-MM-dd', 'en');
      this.patientinsurance.medperc= this.medperc;
      this.patientinsurance.outpatper= this.outpatper;
      this.patientinsurance.labperc= this.labperc;
      this.patientinsurance.notes= this.notes;
      this.patientinsurance.userid= this.userid;
      this.patientinsurance.modifaieddate= formatDate(new Date(), 'yyyy-MM-dd', 'en');
     this.patientinsurance.userid = this.storage.retrieve('stguserId');
     this.patientinsurance.compcode = this.storage.retrieve('stgcompCode'); 
    this.patientinsuranceservice.AddPatientInsurance(this.patientinsurance).subscribe(data => {

      this.mesgSave();

    },

      error => { alert(error); }

    );

}
NewData(){
    this.patientcode = '' ;
    this.medcompany = 0 ;
    this.patientid = '' ;
    this.contcompany = '' ;
    this.expdate =  formatDate(new Date(), 'yyyy-MM-dd', 'en'); 
    this.medperc = 0 ;
    this.outpatper = 0 ;
    this.labperc = 0 ;
    this.notes = '' ;
}
DeletePatientInsurance(){
   this.patientinsuranceservice.delPPatientInsurance(this.patientcode).subscribe(
        (data: PatientInsuranceModel) => {
           
  
        }
      );
      this.dialogRef.close();
}
mesgDelete(){
   Swal({
        title: 'Are you sure?',
        text: 'You will not be able to recover this record!',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        cancelButtonText: 'No, keep it',
      }).then(() => {
          this.DeletePatientInsurance();
          Swal('Deleted!', 'Your record has been deleted.', 'success');
  
        },
        function (dismiss) {
          if (dismiss === 'cancel') {
            Swal('Cancelled', 'Your record is safe :)', 'error');
          }
        }
      );
}
CloseDialog(){
    this.dialogRef.close();
}
mesgSave() {
    swal({
      title: 'Your work has been saved',

      type: 'success',
      showConfirmButton: false,

      timer: 1500
    });
  }
}
